// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "wrapper-39j16";
var _3 = "title-3NNXz";
export { _1 as "__esModule", _2 as "wrapper", _3 as "title" }
export default { "__esModule": _1, "wrapper": _2, "title": _3 }
